import styled from "styled-components";
import { MobergFontFamily } from '../Components/MobergFont/MobergFont';
export const ConfirmationModalContainer = styled.div`
    width: 440px;
    height: 415px;
    background: var(--color-surface-panel);
    border-radius: 8px;
    padding: 30px;
`; // the container of the confirmation modal

export const ConfirmationModalContent = styled.div`
    width: 300px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-bottom: 8px;
    p {
        font-family: ${MobergFontFamily.REGULAR};
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 120%;
        color: var(--text-secondary-color);
        margin-bottom: 0px;
    } // plain text for the confirmation modal content

    h1 {
        font-family: ${MobergFontFamily.HEADER};
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 110%;
        color: var(--color-text-primary);
        margin-bottom: 20px;
    } // header text for the confirmation modal content
`;